<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Bus SOS Request Map</span><br/>
      <span style="font-style: italic; font-size: 18px">shows locations of SOS vehicle and nearby vehicles and yards</span>
    </div>

    <div v-if="!loading">
      <div class="row-none" style="margin: 20px; font-weight: bold; font-size: 20px;">
        <div class="col" style="background-color: lightcoral;">{{ summary.source_tenant_name }} - {{summary.vehicle_name}}</div>
        <div class="col" style="background-color: lightgreen;">Found {{internal_vehicles.length}} Nearby Vehicles</div>
        <div class="col" style="background-color: lightskyblue;">Found {{nearby_yards.length}} Nearby Yards</div>
        <div class="col" style="background-color: lightskyblue;">Found {{registered_yards.length}} Registered Yards</div>
        <div v-if="!standalone">&nbsp;&nbsp;<b-button :to="{ name: 'sos_list'}"><span style="color:white">Back To List</span></b-button></div>
      </div>
      <div class="row-none" style="margin-right: 0px">
        <div v-if="!standalone" class="col" style="overflow-y:scroll; max-height: 900px; max-width: 300px; border: none; padding-right:0px !important">
          <div style="border:1px solid black; font-weight: bold; font-size: 20px">
            <div>SOS Bus Info</div>
            <div @click="toggle_div(veh, veh.name)" v-if="veh.type=='source'" v-for="veh in items" style="background-color: lightcoral; border: 1px solid grey; padding:5px">
              <span style="font-size: 18px; font-weight: bold">{{veh.name}}</span><br/>
            </div>
            <div @click="toggle_div(veh, veh.name)" v-if="veh.type=='begin'"  v-for="veh in items" style="background-color: lightseagreen; border: 1px solid grey; padding:5px">
              <span style="font-size: 18px; font-weight: bold">{{veh.name}} location</span><br/>
            </div>
            <div @click="toggle_div(veh, veh.name)" v-if="veh.type=='arrival'"  v-for="veh in items" style="background-color: lightsalmon; border: 1px solid grey; padding:5px;">
              <span style="font-size: 18px; font-weight: bold">{{veh.name}} location</span><br/>
            </div>
            <span v-if="internal_vehicles.length > 0">
              <br/>
              <div>{{internal_vehicles.length}} Nearby Vehicles</div>
              <div @click="toggle_div(veh, veh.name)" v-if="veh.type=='internal'" v-for="veh in items" style="background-color: lightgreen; border: 1px solid grey; padding:5px">
                <span style="font-size: 18px; font-weight: bold">{{veh.name}}</span><br/>
              </div>
            </span>
            <span v-if="nearby_yards.length > 0">
              <br/>
              <div>{{nearby_yards.length}} Nearby Yards</div>
              <div @click="toggle_div(veh, veh.name)" v-if="veh.type=='yard'" v-for="veh in nearby_yards" style="background-color: lightskyblue; border: 1px solid grey; padding:5px">
                <span style="font-size: 18px; font-weight: bold">{{veh.name}}</span><br/>
              </div>
            </span>
            <span v-if="registered_yards.length > 0">
              <br/>
              <div>{{registered_yards.length}} Registered Yards</div>
              <div @click="toggle_div(veh, veh.name)" v-if="veh.type=='yard'" v-for="veh in registered_yards" style="background-color: lightskyblue; border: 1px solid grey; padding:5px">
                <span style="font-size: 18px; font-weight: bold">{{veh.name}}</span><br/>
              </div>
            </span>
          </div>
        </div>
        <div class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <gmap-map ref="gmap"
                    :zoom="summary.zoom"
                    :center="center"
                    style="width:100%;  height: 900px;"
          >
            <gmap-marker
                v-for="(marker,idx) in markers"
                :position="marker.position"
                :title="marker.title"
                :label="marker.label"
                :draggable="false"
                :icon="marker.icon"
                :clickable="true"
                @mouseover="openInfoWindowTemplate(idx)"
                @mouseout="infoWindow.open=false"
            />
            <gmap-info-window
                :options="{
                              pixelOffset: { width: 0, height: -65 }
                            }"
                :position="infoWindow.position"
                :opened="infoWindow.open"
            >
              <div v-html="infoWindow.template"></div>
            </gmap-info-window>
          </gmap-map>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>
</template>
<script>
import {get_sos_details} from '../networking/apis'
import {mapState} from "vuex";

export default {
  name: 'sos_detail',
  components: {
  },

  data() {
    return {
      items: [],
      sos_locations: [],
      internal_vehicles: [],
      nearby_yards: [],
      registered_yards: [],
      summary: {},
      loading: true,
      center: null,
      markers: [],
      map: null,
      standalone: true,
      booking_list: [],
      vehicle_list: [],
      infoWindow: {
        position: {lat: 0, lng: 0},
        open: false,
        template: ''
      }
    }
  },
  async created() {
    this.load_data()
  },
  methods: {
    toggle_div(item,selected_name) {

      const loc = this.items.filter(item => item.name == selected_name)[0]
      if (loc != null) {
        this.center = {
          lat: Number(loc.latitude),
          lng: Number(loc.longitude),
        };
        this.zoom = 10
      }
    },
    openInfoWindowTemplate(index) {
      const loc = this.items[index]
      const position = {
        lat: Number(loc.latitude),
        lng: Number(loc.longitude),
      };
      this.infoWindow.position = position
      this.infoWindow.template = loc.marker_html
      this.infoWindow.open = true
    },
    async load_data() {
      this.loading = true
      try {
        this.summary = null
        this.items = null
        this.markers = [];
        let tenant_id = this.$route.query.tenant_id
        if (this.user.tenant) {
          tenant_id = this.user.tenant
          this.standalone = false
        } else if ( this.$route.query.tenant_id != null) {
          localStorage.clear()
        }

        const {value: { data = [] } } = await get_sos_details(tenant_id,this.$route.query.request_id)
        this.summary = data.summary
        this.items = data.results
        this.sos_locations = data.sos_locations
        this.internal_vehicles = data.internal_vehicles
        this.nearby_yards = data.nearby_yards
        this.registered_yards = data.registered_yards

        if (this.items && this.items.length > 0) {
          for (const loc of this.items) {
            //console.log("lc-" + loc.name + ":" + loc.latitude + "," + loc.longitude)
            const position = {
              lat: Number(loc.latitude),
              lng: Number(loc.longitude),
            };
            if (loc.type == 'source')
              this.center = position;

            if (loc.type == 'source')
              this.markers.push({position: position, title: loc.name, label:{text:loc.name, className: 'marker-label'}, icon: this.pinSymbol('lightcoral')});
            else if (loc.type == 'begin')
              this.markers.push({position: position, title: loc.name, label:{text:loc.name, className: 'marker-label'}, icon: this.pinSymbol('lightseagreen')});
            else if (loc.type == 'arrival')
              this.markers.push({position: position, title: loc.name, label:{text:loc.name, className: 'marker-label'}, icon: this.pinSymbol('lightsalmon')});
            else if (loc.type == 'internal')
              this.markers.push({position: position, title: loc.name, label:{text:loc.name, className: 'marker-label'}, icon: this.pinSymbol('lightgreen')});
            else
              this.markers.push({position: position, title: loc.name, label:{text:loc.name, className: 'marker-label'}, icon: this.pinSymbol('lightskyblue')});
          }
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    pinSymbol(color) {
      return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: 'black',
        strokeWeight: 1,
        scale: 1.5,
      };
    }
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load()
      }
    }
  }
}
</script>
<style>


</style>
